import React from "react";

function NoMatch() {
  return <p className="mt-5">404 error: Page not found</p>;
}

export default NoMatch;
